import exceljs from "exceljs";
import { saveAs } from "file-saver";
//--------------------------------------------------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import {
    mimeTypeMap, 
    MyDate, 
    numberReducer, 
    getDateEndFromWeekNum
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Export({
    filteredProjects,
    weeks,
    curWeekStart,
    curWeekEnd,
    projectsMap
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const exportFunc = () => {
            if(!filteredProjects.length){
                window.alert("No data to export.");
                return;
            }
            setShowLoader(true);
            const workbook = new exceljs.Workbook();
            workbook.creator = user.userName;
            workbook.created = new Date();
            workbook.calcProperties.fullCalcOnLoad = true;
            const worksheet = workbook.addWorksheet(null, {views: [{showGridLines: false}]});
            worksheet.state = "visible";
            worksheet.properties.defaultColWidth = 22.57;
            const filteredWeeks = weeks.filter(week => 
                week >= curWeekStart && week <= curWeekEnd
            );
            const rows = [];
            for(let i = 0; i < filteredProjects.length; i++){
                const projectHashKey = filteredProjects[i];
                const row = [projectsMap[projectHashKey].projectName];
                for(let week of filteredWeeks){
                    row.push(filteredWeeks[week]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0) || 0);
                }
                const totalAmount = filteredWeeks.map(week => filteredWeeks[week]?.[projectHashKey]?.map(item => item.amount).reduce(numberReducer, 0) || 0).reduce(numberReducer, 0);
                row.push(totalAmount);
                rows.push(row);
            }
            worksheet.addTable({
                name: "MyTable",
                ref: "A1",
                totalsRow: true,
                style: {
                    showRowStripes: true,
                },
                columns: [
                    {name: "Project Name", filterButton: true},
                    ...filteredWeeks.map(week => 
                        ({name: getDateEndFromWeekNum(week), filterButton: true, totalsRowFunction: 'sum'})
                    ),
                    {name: "Billing", filterButton: true, totalsRowFunction: 'sum'},
                ],
                rows: rows,
            });
            //-----------------------------------------------------
            workbook.xlsx.writeBuffer().then(buffer => {
                saveAs(new Blob([buffer], { type: mimeTypeMap.xlsx}), 
                `Billing export ${(new MyDate()).s()}.xlsx`);
                setShowLoader(false);
            })
        };
    return(
        filteredProjects.length?
        <span className = "pointer" onClick = {exportFunc}>
            Export
        </span>
        :<></>
    )
};